module.exports = __webpack_public_path__ + "img/yellow.0b8ded99.png";